<template>
  <div class="app-container">
    <el-form
			:model="searchData"
			:inline="true"
			label-width="140px"
			label-position="right"
			ref="searchData"
		>
			<el-form-item label="省" prop="provinceCode">
				<el-select
					v-model="searchData.provinceCode"
					placeholder="请选择"
					clearable
					style="width: 100%"
					@change="provinceChangeFun"
				>
					<el-option
						v-for="item in provinceList"
						:key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
						style="width: 100%"
					>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="城市" prop="cityCodeList">
				<el-select
					v-model="searchData.cityCodeList"
					placeholder="请选择"
					clearable
          multiple
					style="width: 100%"
					:disabled="!searchData.provinceCode"
				>
					<el-option
						v-for="item in cityList"
						:key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
						style="width: 100%"
					>
					</el-option>
				</el-select>
			</el-form-item>
      <el-form-item label="合作方" prop="partnershipIds">
				<el-select
					v-model="searchData.partnershipIds"
					placeholder="请选择"
					clearable
					style="width: 100%"
          multiple
				>
					<el-option
						v-for="item in managementOptions"
						:key="item.partnershipId"
            :label="item.partnerName"
            :value="item.partnershipId"
						style="width: 100%"
					>
					</el-option>
				</el-select>
			</el-form-item>
      <el-form-item label="回收品类（大类）" prop="spid">
				<el-select
					v-model="searchData.spid"
					placeholder="请选择"
					clearable
					style="width: 100%"
          @change="dlChangeFun"
				>
					<el-option
						v-for="item in dlList"
						:key="item.spid"
            :label="item.spmc"
            :value="item.spid"
						style="width: 100%"
					>
					</el-option>
				</el-select>
			</el-form-item>
      <el-form-item label="回收品类（小类）" prop="xlids">
				<el-select
					v-model="searchData.xlids"
					placeholder="请选择"
					clearable
					style="width: 100%"
          :disabled="!searchData.spid"
          multiple
				>
					<el-option
						v-for="item in xlList"
						:key="item.xlid"
            :label="item.xlmc"
            :value="item.xlid"
						style="width: 100%"
					>
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>

    <div class="btn-group">
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="addCommissionFun">新建</el-button>
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table
			ref="checktableData"
			:data="tableData"
			v-loading="tableLoading"
			:reserve-selection="true"
			center
			height="60vh"
      @selection-change="selectChangeFun"
		>
      <el-table-column type="selection" :selectable="selectableFun" width="55"></el-table-column>
			<el-table-column label="操作" prop="action" width="160">
				<template slot-scope="scope">
          <el-link type="primary" @click="editRowFun(scope.row)">编辑</el-link>
					<el-link style="margin-left: 12px;" type="primary" @click="deleteRowFun(scope.row)">删除</el-link>
				</template>
			</el-table-column>
      <el-table-column label="编号" prop="regionId" min-width="100"></el-table-column>
      <el-table-column label="省份" prop="provinceNames" min-width="100"></el-table-column>
			<el-table-column label="城市" prop="cityNames" min-width="100"></el-table-column>
			<el-table-column label="回收品类（大类）" prop="spmc" min-width="120"></el-table-column>
			<el-table-column label="回收品类（小类）" prop="xlmc" min-width="120"></el-table-column>
			<el-table-column label="型号" prop="xhmc" min-width="120"></el-table-column>

			<el-table-column label="合作方" prop="partnerName" min-width="120"></el-table-column>
			<el-table-column label="抽成金额" prop="commission" min-width="120"></el-table-column>
      <el-table-column label="创建时间" prop="createTime" min-width="120"></el-table-column>
		</el-table>
		<div class="pagination-container">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes,prev, pager, next,jumper"
				:current-page.sync="pagination.currPage"
				:page-size="pagination.pageSize"
				:page-sizes="[10, 20, 30, 50]"
				:total="total"
			>
			</el-pagination>
		</div>
    <AddCommissionDialog ref="addCommissionRef" @opera-success="handleSearch"></AddCommissionDialog>
  </div>
</template>
<script>
// 下拉列表数据provinceList: [],cityList: [],managementOptions: [],dlList: [],xlList: [],在mixins
import selectOptions from '../mixins/selectOptions.js'
import AddCommissionDialog from './components/AddCommissionDialog.vue'
export default {
  components: {
    AddCommissionDialog
  },
  mixins: [selectOptions],
  data(){
    return {
      // 查询数据
      searchData: {
        provinceCode: undefined,
        cityCodeList: undefined,
        partnershipIds: undefined,
        spid: undefined,
        xlids: undefined,
      },
      // 表格数据
      tableData: [],
      tableLoading: false,
      pagination: {
        currPage: 1,
        pageSize: 10
      },
      total: 0,
      selectList: [],
    }
  },
  created(){
    this.getCurOptionsFun()
    this.handleSearch()
  },
  methods: {
    // 获取下拉数据
    getCurOptionsFun () {
      // 获取省份
      this.getTblProvince()
      // 获取合作方
      this.getManagementOptions()
      // 获取大类
      this.getTblSplbDalei()
    },
    // 省改变
    provinceChangeFun () {
      this.searchData.cityCodeList = undefined
      this.getTblCity(this.searchData.provinceCode)
    },
    // 大类改变
    dlChangeFun () {
    	this.searchData.xlids = undefined
      this.getSpXiaolei(this.searchData.spid)
    },
    // 获取分页数据
    getList () {
      const url = `/autoapp-default-server-recovery/api/commission/platform/page`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
			return this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
          this.total = res.data.total || 0
          const resData = res.data.records || []
          this.tableData = resData
        }else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
			})
    },
    // 查询
		handleSearch () {
			this.pagination.currPage = 1
			this.getList()
    },
    // 清空
		resetForm () {
			this.searchData = {
				provinceCode: undefined,
        cityCodeList: undefined,
        partnershipIds: undefined,
        spid: undefined,
        xlids: undefined
			}
    },
    // 页码改变
    handleSizeChange (val) {
      this.pagination.currPage = 1
      this.pagination.pageSize = val
      this.getList()
    },
    handleCurrentChange () {
      this.getList()
    },
    // 选择改变
    selectChangeFun (selection) {
      this.selectList = selection
    },
    // 控制表格行是否可选
    selectableFun (row) {
      return row.waitCount > 0
    },
    // 新建
    addCommissionFun () {
      this.$refs.addCommissionRef.opendDialog('add')
    },
    // 删除
    deleteRowFun (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // console.log('====row', row)
        const regionId = row.regionId
        if (regionId) {
          this.deleteReqFun(regionId)
        }else {
          this.$message.error('参数错误')
        }
      })
    },
    // 删除请求
    deleteReqFun (regionId) {
      const url = `/autoapp-default-server-recovery/api/commission/platform/delete?regionId=${regionId}`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('删除成功')
          this.handleSearch()
        }else {
          const msgTip = res.message || '请求失败'
          this.$message.error(msgTip)
        }
      }, err => {
        console.log('err', err)
      })
    },
    // 编辑
    editRowFun (row) {
      this.$refs.addCommissionRef.opendDialog('edit',row)
    }
  }
}
</script>
<style scoped lang='scss'>
.btn-group{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
	margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/commissionManage/platformCommissionSet/index.vue